import { IFeatureFlag } from '@oliasoft/feature-flags';
import { HOST_BASE_URL } from 'client/common/urls/urls';

// const LOCALHOST = 'localhost';

interface IClientConfig {
  baseApiUrl: string;
  env: string;
  idpServerUrl: string;
  dashboardUrl: string;
  hostBaseUrl: string;
  applicationId: string;
  serverVersion: string;
  enableSessionMonitor: boolean;
  enableUserSessionComponent: boolean;
  enableSettingsMaintenance: boolean;
  enableSentry: boolean;
  sentryEnvironment: string;
  enableReleaseNotes: boolean;
  enableMixpanel: boolean;
  mixpanelApiHost: string;
  mixpanelApiKey: string;
  enableAnalyticsDebugLogs: boolean;
  analyticsEmailDomainExclusions: string;
  overrideAnalyticsEmailExclusions: string;
  featureFlags: {
    enableAllFlags: boolean;
    activeFlags: IFeatureFlag[];
    disabledFlags: string[];
  };
  pkce: {
    provider: 'oidc-client-ts' | 'axa-fr';
    renewTokenMode: 'refresh-token' | 'silent-renew';
  };
}

// const isLocalHost = window.location.hostname === LOCALHOST;

export default class ClientConfig {
  static get config(): IClientConfig {
    const runtimeConfig = window.__runtimeConfigStatic;
    const apiBaseUrl = runtimeConfig?.api_base_url;
    const idpBaseUrl = runtimeConfig?.authentication_server_base_url;
    const dashboardUrl = runtimeConfig?.dashboard_url;
    const enableAllFlags = runtimeConfig?.feature_flags?.enable_all_flags;
    const activeFlags = runtimeConfig?.feature_flags?.active_flags;
    const disabledFlags = runtimeConfig?.feature_flags?.disabled_flags;
    const serverVersion = runtimeConfig?.app_version;
    const enableUserSessionComponent = runtimeConfig?.enable_user_session_component;
    const enableSettingsMaintenance = runtimeConfig?.enable_settings_maintenance;
    const enableReleaseNotes = runtimeConfig?.enable_release_notes;
    const provider = runtimeConfig?.pkce?.provider;
    const renewTokenMode = runtimeConfig?.pkce?.renew_token_mode;
    const env = runtimeConfig?.env;
    const enableMixpanel = runtimeConfig?.enable_mixpanel;
    const mixpanelApiHost = runtimeConfig?.mixpanel_api_host;
    const mixpanelApiKey = runtimeConfig?.mixpanel_api_key;
    const enableAnalyticsDebugLogs = runtimeConfig?.enable_analytics_debug_logs;
    const analyticsEmailDomainExclusions = runtimeConfig?.analytics_email_domain_exclusions;
    const overrideAnalyticsEmailExclusions = runtimeConfig?.override_analytics_email_exclusions;
    const enableSentry = runtimeConfig?.enable_sentry;
    const sentryEnvironment = runtimeConfig?.sentry_environment;

    // let enableSessionMonitor = true;
    // if (window.Cypress) {
    //   enableSessionMonitor = false;
    // }
    // if (isLocalHost && !idpBaseUrl?.includes(LOCALHOST)) {
    //   enableSessionMonitor = false;
    // }

    return {
      env,
      enableSentry,
      sentryEnvironment,
      baseApiUrl: apiBaseUrl,
      idpServerUrl: idpBaseUrl,
      dashboardUrl,
      hostBaseUrl: HOST_BASE_URL,
      applicationId: 'forecast-api',
      serverVersion,
      enableSessionMonitor: false,
      enableUserSessionComponent,
      enableSettingsMaintenance,
      enableReleaseNotes,
      featureFlags: {
        enableAllFlags,
        activeFlags,
        disabledFlags,
      },
      pkce: {
        provider,
        renewTokenMode,
      },
      enableMixpanel,
      mixpanelApiHost,
      mixpanelApiKey,
      analyticsEmailDomainExclusions,
      overrideAnalyticsEmailExclusions,
      enableAnalyticsDebugLogs,
    };
  }
}
export const autoSaveWait = 1500;

export const autoSaveWaitShort = 200;
